import React, {useState} from "react";
import PropTypes from "prop-types";
import styles from "./FileTile.scss";
import classnames from "classnames";
import { shortenFilename } from "utils/text_helpers";

export default function FileTile(props) {
    const getFileIcon = () => {
        switch (props.fileType) {
            case "video":
                return "fas fa-file-video";
            case "audio":
                return "fas fa-file-music";
            case "image":
                return "fas fa-file-image";
            case "pdf":
                return "fas fa-file-pdf";
        }
    };

    if (props.iconOnly) {
        return (
            <div className={styles.fileIcon}>
                <i className={getFileIcon()} />
            </div>
        );
    }

    return (
        <div
            className={classnames(styles.root, {
                [styles.small]: props.small,
                [styles.wider]: props.wider,
            })}
        >
            <div className={styles.fileIcon}>
                <i className={getFileIcon()} />
            </div>
            {props.displayName
                ? props.displayName
                : !!props.fileName
                    ? shortenFilename(props.fileName, 20)
                    : props.fileType}

            {props.onDelete &&
                <div
                    className={styles.deleteButton}
                    onClick={props.onDelete}
                >
                    <i className="fas fa-trash" />
                </div>
            }
        </div>
    );
}

FileTile.propTypes = {
    fileType: PropTypes.oneOf(["video", "audio", "image", "pdf"]),
    fileName: PropTypes.string,
    displayName: PropTypes.string,
    onDelete: PropTypes.func,
    iconOnly: PropTypes.bool,
    small: PropTypes.bool,
    autoWidth: PropTypes.bool,
};
